<template>
  <div>
    <b-modal size="sm" class="modal-size" hide-footer v-model="modal_client" title="NUEVO CLIENTE">
      <b-row>
        <b-col md="12">
          <b-form id="Form" @submit.prevent="AddClient">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Tipo de Documento :">
                    <select
                      ref="document_type"
                      class="form-control"
                      v-model="client.document_type"
                    >
                      <option value="1">DNI</option>
                      <option value="6">RUC</option>
                      <option value="0">OTROS</option>
                    </select>
                    <small
                      v-if="errors.document_type"
                      class="form-text text-danger"
                      >Seleccione un tipo de documento</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Nro Documento :">
                    <b-input-group>
                      <b-form-input
                        v-model="client.document_number"
                        class="form-control"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="info" @click="SearchClient">
                          <b-icon icon="search"></b-icon
                        ></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <small
                      v-if="errors.document_number"
                      class="form-text text-danger"
                      >{{error_document_number}}</small
                    >
                  </b-form-group>
                </b-col>
            

                <b-col md="12">
                  <b-form-group label="Nombres / Razón Social:" required>
                    <b-form-input
                      type="text"
                      ref="name"
                      v-model="client.name"
                      placeholder="Ingrese su nombre"
                    ></b-form-input>
                    <small v-if="errors.name" class="form-text text-danger"
                      >Ingrese un nombre o razón social</small
                    >
                  </b-form-group>
                </b-col>
     

                <b-col md="12">
                  <b-form-group label="Pais :">
                    <b-form-select ref="country" v-model="client.country" :options="countries"></b-form-select>
                  </b-form-group>
                </b-col>

    

                <b-col md="12">
                  <b-form-group label="Teléfono :" required>
                    <b-form-input
                      type="text"
                      ref="phone"
                      v-model="client.phone"
                      placeholder="Ingrese su Telefono"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
      

                <b-col md="12">
                  <b-button
                    type="submit"
                    class="form-control bg-primary text-white"
                    variant="primary"
                    >GUARDAR</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
        </b-col>
  
      </b-row>
    </b-modal>
  </div>
</template>

<style>

.modal-sm{
  max-width: 40% !important;

}
</style>

<script>

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import EventBus from "@/assets/js/EventBus";
import converter from "@/assets/js/NumberToLetters";
export default {
  name: "ModalClient",
  data() {
    return {
        module: 'Client',
        role:2,

        modal_client: false,
        client: {
          document_type: "1",
          document_number: "",
          name: "",
          country: "PE",
          ubigee: "",
          address: "",
          phone: "",
          email: "",
          state: 1,
        },

        countries:[
           { value :"PE", text: 'Peru'},
           { value :"CL", text: 'Chile'},
        ],
        ubigens: [
          { value :"202020", text: 'Tacna'},
        ],
        //errors
        errors: {
          document_type: false,
          document_number: false,
          name: false,
        },
        validate: false,
        error_document_number :''
    };
  },
  created (){
    
  },
  mounted () {
    EventBus.$on('ModalClient', () => {
      this.modal_client = true;
    });
  },
  methods: {
    AddClient,
    Validate,
    SearchClient,
  },
  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    }
  },
};


function SearchClient() {


  let me = this;
  if (me.client.document_type == 1) {
      if (me.client.document_number.length == 8) {
        me.errors.document_number = false;
        axios({
          method: "GET",
          url: 'https://dni.optimizeperu.com/api/persons/'+me.client.document_number,
        }).then(function (response) {
          console.log(response);
            if (response.data.name != undefined ) {
              me.client.name = response.data.name + ' ' + response.data.first_name + ' ' + response.data.last_name;
            }
        })
      }else{
        me.errors.document_number = true;
        me.error_document_number = 'El nro de ducumento debe contener 8 digitos';
      }
  }

  if (me.client.document_type == 6) {
      if (me.client.document_number.length == 11) {
        me.errors.document_number = false;
        axios({
          method: "GET",
          url: 'https://dni.optimizeperu.com/api/company/'+me.client.document_number,
        }).then(function (response) {
          console.log(response);
            if (response.data.razon_social != undefined ) {
              me.client.name = response.data.razon_social;
            }
        })
      }else{
        me.errors.document_number = true;
        me.error_document_number = 'El nro de ducumento debe contener 11 digitos';
      }
  }
  
}


function AddClient() {
  // validacion de campos obligatorios
  this.Validate();
  if (this.validate) {
    return false;
  }

  let me = this;
  let url = this.url_base + "client/add";
  let data = this.client;

  axios({
    method: "POST",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      token: this.token,
      module: this.module,
      role: this.role,
    },
  })
    .then(function (response) {
      if (response.data.status == 201) {

        me.client.document_type = 1;
        me.client.document_number = "";
        me.client.name = "";
        me.client.country = "PE";
        me.client.ubigee = "";
        me.client.address = "";
        me.client.phone = "";
        me.client.email = "";
        me.client.state = 1;
        me.modal_client = false;
        Swal.fire("Sistema", "Se ha creado el nuevo cliente", "success");
      } else if (response.data.status == 400) {
        Swal.fire("Sistema", "El cliente ingresado ya se encuentra registrado", "warning");
      }else{
        Swal.fire("Sistema", "A Ocurrido un error", "error");
      }
    })
}

function Validate() {

  // if (this.client.document_type == 1) {
  //   this.errors.document_number = this.client.document_number.length != 8 ? true : false;
  //   this.error_document_number = 'El nro de ducumento debe contener 8 digitos';
  // }else if(this.client.document_type == 6){
  //   this.errors.document_number = this.client.document_number.length != 11 ? true : false;
  //   this.error_document_number = 'El nro de ducumento debe contener 11 digitos';
  // }else{
  //   this.errors.document_number = this.client.document_number.length == 0 ? true : false;
  //   this.error_document_number = 'Ingrese un nro de documento';
  // }

  // this.errors.document_type = this.client.document_type.length == 0 ? true : false;
  // this.errors.name = this.client.nathis.length == 0 ? true : false;

  // if (this.errors.document_type) { this.validate = true; return false;}else{ this.validate = false; }
  // if (this.errors.document_number) { this.validate = true; return false;}else{ this.validate = false; }
  // if (this.errors.name) { this.validate = true; return false;}else{ this.validate = false; }


}
</script>
